import * as React from 'react';

import classnames from 'classnames';

import {HelpButton} from '../help/help-button';
import {PopoverInfo} from '../popover-info/popover-info';
import type {PopoverInfoBodyColor} from '../popover-info/popover-info';

import styles from './metrics.module.css';

type Props = {
    title: string | null | undefined;
    tooltipInfo?: string | React.ReactNode;
    tooltipBodyColor?: PopoverInfoBodyColor;
    onHelpClick?: () => void | null | undefined;
    size: 'small' | 'normal' | 'big';
    isAlignedCenter?: boolean;
};

const SIZE_MAP = {
    small: 12,
    normal: 15,
    big: 18,
} as const;

export function MetricHeader(props: Props) {
    const sizeValue = SIZE_MAP[props.size];
    const styleName = classnames(styles['stat-label'], {
        [styles['stat-label--center']]: props.isAlignedCenter,
    });

    return (
        <div className='flex align-center'>
            <span className={styleName}>{props.title}</span>
            {(props.tooltipInfo || props.onHelpClick) && (
                <div className={styles['tooltip-wrapper']}>
                    {props.tooltipInfo ? (
                        <PopoverInfo
                            size={sizeValue}
                            info={props.tooltipInfo}
                            bodyColor={props.tooltipBodyColor}
                        />
                    ) : (
                        // @ts-expect-error
                        <HelpButton size={sizeValue} onClick={props.onHelpClick} />
                    )}
                </div>
            )}
        </div>
    );
}
